<script lang="ts">
  import { pop, push } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import { type Writable, writable } from "svelte/store";
  import { type Table, TableComp } from "$components";
  import { SitesSortFields, SortOrder } from "$apis/parkito";

  let tableData: Writable<Table.Data<3>> = writable({
    headers: [
      { title: "Namn", type: "text" },
      { title: "Anläggning", type: "text" },
      { title: "Datum", type: "text" },
    ],
    rows: [],
  });

  $tableData.rows = [
    {
      id: "001",
      col: ["Meddelande 1", "Brf Bulten", "2021-09-01"],
    },
    {
      id: "002",
      col: ["Meddelande 2", "Brf Bulten", "2021-09-03"],
    },
    {
      id: "003",
      col: ["Renovering av innertak", "Brf Metropolen", "2021-09-06"],
    },
  ];

  let tableSort: Table.Sort = {
    by: SitesSortFields.CODE,
    order: SortOrder.ASC,
  };

  const itemClicked = (i: number) => {
    push(`/messages/${$tableData.rows[i].id}`);
  };

  onMount(() => {
    if (import.meta.env.DEV) console.log("Messages mounted.");
  });
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px] min-[480px]:hidden"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Meddelanden
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <!-- Table -->
  <div class="max-mobile:mx-[-8px]">
    <TableComp
      bind:tableData={$tableData}
      bind:sort={tableSort}
      onClick={itemClicked}
      let:prop={row}
    >
      <td>{row.col[0]}</td>
      <td>{row.col[1]}</td>
      <td>{row.col[2]}</td>
    </TableComp>
  </div>
</div>
